export default __webpack_public_path__ + "static/media/wegovy-clean-the-injection-site.6fa3d22c.mp4";